// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section.box[data-v-1c6060a8]{background-color:#f6f6f6;padding-bottom:50px;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
